import type { Paywall } from "@/react/types";
import { DataTable } from "@circle-react-uikit/DataTable";
import { Loader } from "@circle-react-uikit/Loader";
import { columnsListComponent } from "./constants";
import { useList } from "./hooks/useList";

interface ListProps {
  isPaywallsLoading?: boolean;
  paywalls?: Paywall[];
  refetchPaywalls: () => void;
}

export const List = ({
  isPaywallsLoading,
  paywalls,
  refetchPaywalls,
}: ListProps) => {
  const { dataSource } = useList({
    paywalls,
    refetchPaywalls,
  });

  return isPaywallsLoading ? (
    <Loader />
  ) : (
    <div data-testid="paywall-list">
      {dataSource && dataSource.length > 0 && (
        <DataTable
          columns={columnsListComponent}
          className="md:mb-20"
          dataSource={dataSource}
          hasStickyHeader
          headerClassName="top-[116px]"
        />
      )}
    </div>
  );
};
